<!-- for desktop view -->
<nav :class="[ $style.fouNavigation, showHamIcon ? $style.open : '', getImpersonateUser ? $style.shiftToBottom : '' ]" @mouseleave="menu=false" role="navigation">
  <div :class="[$style.navInner, !user.authenticated && $style.padding10Tb]">
    <div :class="[ $style.leftPanel, showHamIcon ? $style.open : '' ]">
      <div :class="$style.logo">
        <!-- HamBurgerLogo -->
        <div :class="[$style.mobileMenu, showHamIcon ? $style.open : '' ]" @click="changeHamIconStatus" v-if="user.authenticated && isValidNavigation">
          <span :class="$style.mobileMenuBar"></span>
          <span :class="$style.mobileMenuBar"></span>
          <span :class="$style.mobileMenuBar"></span>
        </div>
        <!-- Foundry Logo -->
        <span :id="$vId(this, 'link-home')"
          @click="setFoundryForModule(defaultFoundry, foundries, '', '', getAuthRoles, 'monotypelogo')"
          :class="[$style.homeItemLink, $style.homeLink]">
          <h5 :class="$style.homeLinkTitle">{{$t('components.general.fou_navigation.foundry_platform')}}</h5>
        </span>
      </div>
      <div :class="$style.internaltag" v-if="hasRole(['foundrySupport', 'bulkIngestionUser']) && !getImpersonateUser">
          <RectangleTag>
            {{$t('components.general.fou_navigation.internal_tag')}}
          </RectangleTag>
      </div>
    </div>
    <!-- Header Navigation -->
    <div :class="[ $style.rightPanel, showHamIcon ? $style.open : '' ]" v-if="user.authenticated && isValidPermissionArr()" @click="changeHamIconStatus(false)">
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && (getNavigationTabsPermission('promotions') || hasRole(['foundrySupport']) || getImpersonateUser) && !hasRole(['FS-Impersonate']) && !hasRole(['foundryUser']) && !hasRole([''])">
        <a
          :class="[$style.navItemLink]"
          :id="$vId(this, 'promotions')"
          @click="createNewPromotionRedirection">
          <star-icon :className="$style.navIcon" width="16" height="16"/>
          {{$t('components.general.fou_navigation.create_new_promotion')}}
        </a>
      </div>
      <!-- Create Submission -->
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && (getNavigationTabsPermission('submissions') || getImpersonateUser)">
        <MdTooltip v-if="isContractLocked" trigger="hover" padding="medium" hidedelay="0" placement="bottom">
          <a slot="trigger"
            :class="[$style.navItemLink, 'disabled']"
            :id="$vId(this, 'submission')">
            <upload-icon :className="$style.navIcon" width="16" height="16"/>
            {{$t('components.general.fou_navigation.submit_fonts')}}
          </a>
          <span slot="content" class="fou-tooltip__content">
            {{ $t('components.general.contract_termination.tooltip.label') }}
          </span>
        </MdTooltip>
        <a
          v-else
          :class="[$style.navItemLink]"
          :id="$vId(this, 'submission')"
          @click="createNewSubmission()">
          <upload-icon :className="$style.navIcon" width="16" height="16"/>
          {{$t('components.general.fou_navigation.submit_fonts')}}
        </a>
      </div>
      <!-- brand your profile  -->
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && (getNavigationTabsPermission('Foundry Profile') || getImpersonateUser) && (!foundryBannerURL || !foundryLogoURL) && hasFoundryProfilePermission">
        <MdTooltip v-if="isContractLocked" trigger="hover" padding="medium" hidedelay="0" placement="bottom">
          <a slot="trigger"
            :class="[$style.navItemLink, 'disabled']"
            :id="$vId(this, 'branding')">
            <MdIconCompany :className="$style.navIcon" color="blue-duck--500"/>
            {{$t('components.general.fou_navigation.brand_your_profile')}}
          </a>
          <span slot="content" class="fou-tooltip__content">
            {{ $t('components.general.contract_termination.tooltip.label') }}
          </span>
        </MdTooltip>
        <a
          v-else
          :class="[$style.navItemLink]"
          :id="$vId(this, 'branding')"
          @click="brandYourProfile()">
          <MdIconCompany :className="$style.navIcon" color="blue-duck--500"/>
          {{$t('components.general.fou_navigation.brand_your_profile')}}
        </a>
      </div>
      <!-- videos and articles  -->
      <div :class="[$style.navItem]" v-if="user.authenticated && isValidNavigation && !hasRole(['foundrySupport', 'bulkIngestionUser'])" ref="videosAndArticlesBtn" id="videosAndArticlesBtn">
        <MdTooltip v-if="isContractLocked" trigger="hover" padding="medium" hidedelay="0" placement="bottom">
          <a slot="trigger"
            :class="[$style.navItemLink, 'disabled']"
            :id="$vId(this, 'videos')">
            <MdIconResources :className="$style.navIcon" color="blue-duck--500"/>
            {{$t('components.general.fou_navigation.videos_and_articles')}}
          </a>
          <span slot="content" class="fou-tooltip__content">
            {{ $t('components.general.contract_termination.tooltip.label') }}
          </span>
        </MdTooltip>
        <a
          v-else
          :class="[$style.navItemLink]"
          :id="$vId(this, 'videos')"
          @click="navigateToVideos()">
          <MdIconResources :className="$style.navIcon" color="blue-duck--500"/>
          {{$t('components.general.fou_navigation.videos_and_articles')}}
        </a>
      </div>
      <!-- agreement modal  -->
      <SignAgreementModal v-if="showAgreementModal" :agreementButtonDisabled="hasAgreementsPermission" @handleButtonAction="navigateToAgreementSection" @closeSmallPopupInfoModal="showAgreementModal = false" ref="signAgreementModal" :heading="$t('components.general.sign_agreement_modal.heading')" :body="$t('components.general.sign_agreement_modal.body')" :btnText="$t('components.general.sign_agreement_modal.sign_agreement')" />  
      <!-- Support -->
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && !hasRole(['foundrySupport', 'bulkIngestionUser'])">
        <a
          :class="[$style.navItemLink]"
          :id="$vId(this, 'support')"
          href='https://foundrysupport.monotype.com'
          target='_blank'
          rel="noopener noreferrer"
          @click="navigateToFoundryHelpCenter">
          <MdIconComplianceExecution :className="$style.navIcon" color="blue-duck--500" />
          {{$t('components.general.fou_navigation.help')}}
        </a>
      </div>
      <div :class="$style.navItem" v-if="user.authenticated && isValidNavigation && hasRole(['foundrySupport', 'bulkIngestionUser'])">
        <a
          :class="[$style.navItemLink]"
          :id="$vId(this, 'user_manual')"
          :href="USER_MANUAL_URL"
          target="_blank"
          rel="noopener noreferrer">
          <MdIconResources :class="$style.resourceIcon" size="sm" as="icon" icontitle="disabled" color="blue-duck--500"/>
          {{$t('components.general.fou_navigation.support')}}
        </a>
      </div>
      <div :class="$style.navItem" v-if="!user.authenticated && !isLogin">
        <a
          :class="$style.navItemLink"
          :id="$vId(this, 'link-login')"
           href="/login">
          {{$t('components.navigation.login')}}
        </a>
      </div>
       <!-- Beamer -->
       <div :class="$style.navItemLink" v-if="user.authenticated && isValidNavigation && !hasRole(['foundrySupport', 'bulkIngestionUser'])" id="callBeamer" @click="beamerCJAEvent">
        <NotificationBell/>
       </div>
      <!-- Header Profile -->
      <div :class="$style.navItem" v-if="user.authenticated">
        <span v-if="imageURL" @click="toggleMenu">
        <img :src="imageURL" alt="Profile Picture" :class="$style.profilePic"/>
        </span>
          <a
          v-else
            :class="[$style.menueOpener, {[$style.open]: showMenuBox}]"
            @click="toggleMenu"
            :id="$vId(this, 'profile-icon')"
          >
            <span :class="$style.title">{{getDisplayName().charAt(0)}}</span>
          </a>
          <transition name="fade">
          <div :class="$style.menueBox" v-if="showMenuBox" :id="$vId(this, 'profile-modal-container')">
              <div class="mt-group" :class="$style.menuContent">
                <div :class="$style.profileDropdownBox">
                  <div v-if="imageURL">
                    <img :src="imageURL" alt="Profile Picture" :class="$style.profilePicPart"/>
                  </div>
                    <div v-else :class="$style.avatarPart">
                      <span :class="$style.title" :id="$vId(this, 'profile-modal-icon')">{{getDisplayName().charAt(0)}}</span>
                    </div>
                    <div :class="$style.userNamePart">
                      <div :title="user.displayName" :class="[$style.userName, $style.mB16]" :id="$vId(this, 'profile-modal-username')">{{getDisplayName()}}</div>
                      <div :title="user.name" :class="$style.userEmail" :id="$vId(this, 'profile-modal-email')">{{loggedEmail}}</div>
                    </div>
                </div>
                <MdTypography v-if="showUserProfile"  :class="$style.dropdownLinkLabel" variant="micro1--medium" color="spirits--700">
                  {{$t('components.general.fou_navigation.user_profile')}}</MdTypography>
                <div :class="$style.dropdownLinkProfile" v-if="showUserProfile">
                  <a :href="getProfileUrl()" rel="noopener noreferrer" target="_blank" :class="$style.dropdownLink" :id="$vId(this, 'user-profile')" @click="myAccountCJAEvent">
                    {{$t('components.general.fou_navigation.my_account')}}
                  </a>
                </div>

                <!--  Monotype and MyFonts links-->
                <div v-if="showMonotypeFonts() && (hasRole(['foundryUser']) || hasRole(['FS-Impersonate']) || hasRole(['']))">
                  <MdTypography variant="micro1--medium" color="spirits--700">
                    {{$t('components.general.fou_navigation.monotype_fonts')}}</MdTypography>
                  <div :class="$style.dropdownLinkProfile">
                    <a :href="MTFontsUrl" rel="noopener noreferrer" target="_blank" :class="$style.dropdownLink" :id="$vId(this, 'monotype_fonts')" @click="monotypeDashboardCJAEvent">
                      {{$t('components.general.fou_navigation.monotype_dashboard')}}
                    </a>
                  </div>
                </div>

                <div v-if="hasRole(['foundryUser']) || hasRole(['FS-Impersonate']) || hasRole([''])">
                  <MdTypography variant="micro1--medium" color="spirits--700">
                    {{$t('components.general.fou_navigation.my_fonts')}}</MdTypography>
                  <div :class="$style.dropdownLinkProfile">
                    <a :href="myFontsUrl" rel="noopener noreferrer" target="_blank" :class="$style.dropdownLink" :id="$vId(this, 'monotype_fonts')">
                      {{$t('components.general.fou_navigation.visit_myFonts')}}
                    </a>
                  </div>
                </div>
                <!--  -->
                <div :class="$style.dropdownLinkProfile" v-if="user.authenticated && isValidNavigation && (hasRole(['foundrySupport']) || hasRole(['bulkIngestionUser']))">
                  <a
                    :class="$style.dropdownLink"
                    :id="$vId(this, 'user-manual')"
                    :href="'https://monotype.atlassian.net/wiki/spaces/ENG/pages/5581865223/Inventory+Ingestion+Hub+IIH+User+Manual+draft'"
                    target='_blank'
                    rel="noopener noreferrer">
                    {{ $t('components.general.fou_navigation.support') }}
                  </a>
                </div>
                <div :class="$style.dropdownLinkProfile" v-if="user.authenticated && isValidNavigation && hasRole(['bulkIngestionUser'])">
                  <a
                    :class="$style.dropdownLink"
                    :id="$vId(this, 'studio-user')"
                    :href="'mailto:inventoryinternal@monotype.com'"
                    target='_blank'
                    rel="noopener noreferrer">
                    {{ $t('components.general.fou_navigation.contact_inventory') }}
                  </a>
                </div>
              </div>
              <div :class="$style.logoutButtonBox">
                <a
                  :id="$vId(this, 'link-logout')"
                  class="mt-button"
                  :class="$style.logoutButton"
                  @click="handleLogOut">
                  {{$t('components.general.fou_navigation.log_out')}}
                </a>
              </div>
              <ul class="mt-group mt-list otherGroup">
                <li class="mt-list-item mt-line" v-if="settingsFeature">
                  <a
                    :id="$vId(this, 'link-settings')"
                    href="/settings"
                    :class="$style.greyLink"
                    @click="setMenu">
                    {{$t('components.navigation.manage_account')}}
                  </a>
                </li>
              </ul>
            </div>
          </transition>
      </div>
    </div>
  </div>
</nav>
